// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const safeJsonParse = <T = Record<string, any>>(string: string): T | null => {
	try {
		return JSON.parse(string);
	} catch {
		return null;
	}
};

export function safeStringify(obj: unknown): string {
	try {
		return JSON.stringify(obj);
	} catch {
		return '{}';
	}
}
